import commonMixin from '../../mixins/_common';
import modalMixin from '../../mixins/_modal';
import showStaticHtml from '../../components/_show_static_html';
import imageSelecter from '../../components/_image_selecter';
import tableEditor from './../../components/_table_editor';
import pathNames from './../../components/category/_path_names';

// 期間のフォーマット
const FORMAT = 'YYYY/M/D HH:mm';

/**
 * プレビューのコンポーネント
 */
export default {
    name: 'preview',
    template: '#preview_component_template',
    data() {
        return {
            // タイトル
            title: null,
            // プレビューする商品データ
            item_data: {},
            // カテゴリ一覧データ
            categories: [],
        };
    },
    props: {
        // 編集ID
        edit_id: {
            type: [String, Number],
            require: true
        }
    },
    computed: {
        // 商品データがセットされているか
        hasItemData: function () {
            return (Object.keys(this.item_data).length > 0);
        },
        // 在庫有無フラグ
        inStock: function () {
            if (!this.hasItemData) {
                return false;
            }
            // 通常在庫
            if (this.item_data.stock_config.type === 'normal') {
                if (this.item_data.stock_config.normal_stock_quantity !== null && this.item_data.stock_config.normal_stock_quantity > 0) {
                    return true;
                }
                return false;
            }
            // 表在庫
            const values = this.item_data.subcodes_config.values;
            for (const rowIndex in values) {
                for (const colIndex in values[rowIndex]) {
                    const value = values[rowIndex][colIndex]['quantity'];
                    if (value !== null && value > 0) {
                        return true;
                    }
                }
            }
            return false;
        },
        // 在庫数を◯と×に変換した設定データにする
        subcodesConfig: function () {
            let config = _.cloneDeep(this.item_data.subcodes_config);
            for (const rowIndex in config.values) {
                for (const colIndex in config.values[rowIndex]) {
                    const value = config.values[rowIndex][colIndex]['quantity'];
                    config.values[rowIndex][colIndex]['quantity'] = (value !== null && value > 0) ? '◯' : '×';
                }
            }
            return config;
        },
        // 改行を<br>変換した商品情報
        explanation: function () {
            let value = this.item_data.explanation;
            value = this.$_htmlEscape(value);
            value = this.$_convertToBrTag(value);
            return value;
        },
        // 通常価格
        price: function () {
            return  (this.hasItemData) ? Number(this.item_data.price).toLocaleString() : '';
        },
        // セール価格
        salePrice: function () {
            if (!this.hasItemData || typeof this.item_data.sale_price === 'undefined' || !this.item_data.sale_price.length) {
                return '';
            }
            return Number(this.item_data.sale_price).toLocaleString();
        },
        // 割引率
        discountRate: function () {
            if (!this.salePrice) {
                return '';
            }
            return Math.floor((1 - (Number(this.item_data.sale_price) / Number(this.item_data.price))) * 100);
        },
        // 割引額
        discountPrice: function () {
            if (!this.salePrice) {
                return '';
            }
            const price = Number(this.item_data.price) - Number(this.item_data.sale_price);
            return price.toLocaleString();
        },
        // 販売期間
        salePeriod: function () {
            if (!this.salePrice || !this.item_data.sale_period_start || !this.item_data.sale_period_end) {
                return '';
            }
            return this.salePeriodStart + '～' + this.salePeriodEnd;
        },
        // 販売開始日
        salePeriodStart: function () {
            if (!this.salePrice || !this.item_data.sale_period_start) {
                return '';
            }
            return moment(this.item_data.sale_period_start).format(FORMAT);
        },
        // 販売終了日
        salePeriodEnd: function () {
            if (!this.salePrice || !this.item_data.sale_period_end) {
                return '';
            }
            return moment(this.item_data.sale_period_end).format(FORMAT);
        },
        // セール中か
        onSale: function () {
            if (this.salePeriod) {
                const now = moment();
                const start = moment(this.item_data.sale_period_start);
                const end = moment(this.item_data.sale_period_end);
                if (now.isBetween(start, end)) {
                    return true;
                }
            }
            return false;
        },
        // 定価(メーカー希望小売価格)
        originalPrice: function () {
            if (!this.hasItemData || typeof this.item_data.original_price === 'undefined' || this.item_data.original_price === null || !this.item_data.original_price.length) {
                return '';
            }
            return Number(this.item_data.original_price).toLocaleString();
        },
        // 定価からの割引率
        discountRateFromOriginalPrice: function () {
            if (!this.originalPrice) {
                return '';
            }
            return Math.floor((1 - (Number(this.item_data.price) / Number(this.item_data.original_price))) * 100);
        },
        // 定価からの割引額
        discountPriceFromOriginalPrice: function () {
            if (!this.originalPrice) {
                return '';
            }
            return (Number(this.item_data.original_price) - Number(this.item_data.price)).toLocaleString();
        },
        // 販売期間前か
        beforeSale: function () {
            if (this.salePeriod) {
                const now = moment();
                const start = moment(this.item_data.sale_period_start);
                if (now.isBefore(start)) {
                    return true;
                }
            }
            return false;
        },
        // 販売期間後か
        afterSale: function () {
            if (this.salePeriod) {
                const now = moment();
                const end = moment(this.item_data.sale_period_end);
                if (now.isAfter(end)) {
                    return true;
                }
            }
            return false;
        },
    },
    mixins: [
        commonMixin,
        modalMixin,
    ],
    components: {
        // 画像の選択、UPロードを操作するコンポーネント
        'image-selecter': imageSelecter,
        // 静的HTMLを表示するコンポーネント
        'show-static-html': showStaticHtml,
        // 表設定編集コンポーネント
        'table-editor': tableEditor,
        // パス表示コンポーネント
        'path-names': pathNames,
    },
    methods: {
        // プレビューを開く
        show: function (title, itemData) {
            this.title = title;
            this.item_data = itemData;
            // カテゴリデータ更新
            this.updateCategories();
            this.open();
        },
        // カテゴリデータ更新
        updateCategories: function () {
            this.$nextTick(function() {
                const lefs = this.$root.$refs;
                if (typeof lefs.itemEditor !== 'undefined' && typeof lefs.itemEditor.$refs.category !== 'undefined') {
                    this.categories = lefs.itemEditor.$refs.category.getCategories();
                } else if (typeof lefs.firstCategorySelect !== 'undefined') {
                    this.categories = lefs.firstCategorySelect.getCategories();
                }
            });
        },
    }
};

